import { render, staticRenderFns } from "./SwitchCom.vue?vue&type=template&id=3754515c&scoped=true&"
import script from "./SwitchCom.vue?vue&type=script&lang=js&"
export * from "./SwitchCom.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCom.vue?vue&type=style&index=0&id=3754515c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754515c",
  null
  
)

export default component.exports